module.exports = __webpack_public_path__ + "static/media/leaf.5bd4d23f.svg";